import React, { useState } from "react";
import { Input, HelperText } from "@windmill/react-ui";
import { AiOutlineEye } from "react-icons/ai";
import { AiOutlineEyeInvisible } from "react-icons/ai";
const InputArea = ({
  register,
  defaultValue,
  required,
  name,
  label,
  type,
  autoComplete,
  placeholder,
  error,
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const isValid = !error;


  const isPasswordType = type === "password";

  return (
    <div className="mb-4 relative">
      <label htmlFor={name} className="text-slate-700 mb-2 font-medium">
        {label}
      </label>
      <Input
        id={name}
        {...register(name, {
          required: required ? `${label} is required!` : false,
        })}
        defaultValue={defaultValue}
        type={isPasswordType ? (showPassword ? "text" : "password") : type}
        placeholder={placeholder}
        name={name}
        autoComplete={autoComplete}
        valid={isValid}
        className={`border px-2 h-[40px] rounded-[10px] focus:outline-none ${
          error ? "border-red-500" : "border-slate-200 focus:border-primary"
        } pr-10`} // add right padding for eye icon
        aria-invalid={error ? "true" : "false"}
      />

      {/* Eye icon toggle */}
      {isPasswordType && (
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-3 top-[38px] text-gray-500 hover:text-gray-700 focus:outline-none"
          tabIndex={-1}
          aria-label={showPassword ? "Hide password" : "Show password"}
        >
          {showPassword ? (
            <>
              <AiOutlineEye  className="text-xl"/>
            </>
          ) : (
            <>
              <AiOutlineEyeInvisible className="text-xl" />
            </>
          )}
        </button>
      )}

      {error && (
        <HelperText className="text-xs text-red-500" valid={false}>
          {error.message}
        </HelperText>
      )}
    </div>
  );
};

export default InputArea;
